import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Solutions from './components/Solutions';
import HowItWorks from './components/HowItWorks';
import Differentials from './components/Differentials';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schemaOrg = [
  {
    "@context": "https://schema.org",
    "@type": "FinancialService",
    "name": "Feenex",
    "description": "Soluções corporativas em direitos creditórios e ativo moeda para redução legal de impostos com total conformidade e segurança jurídica.",
    "url": SITE_URL,
    "telephone": "+55-11-4063-4000",
    "email": "contato@feenex.com.br",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Av. Brigadeiro Faria Lima, 3477",
      "addressLocality": "São Paulo",
      "addressRegion": "SP",
      "postalCode": "04538-133",
      "addressCountry": "BR"
    },
    "areaServed": "BR",
    "priceRange": "$$$$",
    "sameAs": []
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Feenex",
    "url": SITE_URL,
    "description": "Soluções corporativas em direitos creditórios e ativo moeda para redução legal de impostos.",
    "inLanguage": "pt-BR",
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${SITE_URL}/?s={search_term_string}`,
      "query-input": "required name=search_term_string"
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Feenex - Redução Legal de Impostos com Direitos Creditórios e Ativo Moeda",
    "description": "A Feenex oferece soluções corporativas estruturadas em direitos creditórios e ativo moeda para empresas que buscam eficiência tributária com total conformidade legal.",
    "url": SITE_URL,
    "inLanguage": "pt-BR",
    "isPartOf": {
      "@type": "WebSite",
      "name": "Feenex",
      "url": SITE_URL
    },
    "about": {
      "@type": "FinancialService",
      "name": "Feenex"
    },
    "dateModified": "2025-07-14"
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "O que são direitos creditórios e como funcionam na prática?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Direitos creditórios são ativos financeiros que representam o direito de receber valores futuros decorrentes de operações comerciais, financeiras ou de prestação de serviços. Na prática, empresas podem utilizar esses ativos como instrumento de planejamento tributário legal, estruturando operações que permitem a compensação ou redução de tributos como IRPJ, CSLL, PIS e COFINS, sempre dentro dos limites estabelecidos pela legislação brasileira."
        }
      },
      {
        "@type": "Question",
        "name": "A redução de impostos com direitos creditórios é legal e segura?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Sim. Todas as operações estruturadas pela Feenex são 100% amparadas pela legislação vigente, incluindo o Código Tributário Nacional e normas da Receita Federal. Cada operação conta com parecer jurídico de advogados tributaristas especializados e é auditável a qualquer momento. Nosso histórico é de zero autuações fiscais."
        }
      },
      {
        "@type": "Question",
        "name": "Qual o percentual de redução de impostos que minha empresa pode alcançar?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "O percentual varia conforme o porte, regime tributário e setor da empresa. Em média, nossos clientes alcançam entre 20% e 34% de redução na carga tributária. Empresas do Lucro Real com faturamento acima de R$ 5 milhões ao ano tendem a ter maior potencial de economia."
        }
      },
      {
        "@type": "Question",
        "name": "Quais impostos podem ser reduzidos com as soluções da Feenex?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "As soluções da Feenex atuam principalmente sobre IRPJ, CSLL, PIS e COFINS. Dependendo da estrutura da empresa, também é possível otimizar outros tributos federais. A estratégia é sempre personalizada após análise detalhada da situação tributária de cada cliente."
        }
      },
      {
        "@type": "Question",
        "name": "O que é ativo moeda e como ele se diferencia dos direitos creditórios?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "O ativo moeda é uma modalidade específica de ativo financeiro reconhecido pela legislação brasileira que pode ser utilizado como meio de pagamento de obrigações tributárias. Enquanto os direitos creditórios representam recebíveis futuros, o ativo moeda possui liquidez imediata para fins fiscais."
        }
      },
      {
        "@type": "Question",
        "name": "Minha empresa precisa ser de qual porte ou setor para se beneficiar?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "As soluções da Feenex são voltadas para empresas tributadas pelo Lucro Real, geralmente com faturamento anual acima de R$ 5 milhões. Atendemos empresas de diversos setores: indústria, comércio, agronegócio, saúde, tecnologia, construção civil e serviços."
        }
      },
      {
        "@type": "Question",
        "name": "Quanto tempo leva para ver os resultados na prática?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Após a conclusão do diagnóstico e estruturação da solução — processo que leva em média de 30 a 60 dias — os benefícios tributários começam a ser aplicados já no período fiscal seguinte. O monitoramento contínuo é realizado por até 5 anos."
        }
      },
      {
        "@type": "Question",
        "name": "Como funciona o processo de contratação e quais são os custos?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "O processo começa com um diagnóstico inicial gratuito, sem compromisso. Nossa remuneração é baseada em performance — alinhamos nossos interesses aos seus resultados. Não há custos fixos elevados antes de comprovada a viabilidade da operação."
        }
      },
      {
        "@type": "Question",
        "name": "A Receita Federal pode questionar ou autuar minha empresa por usar essas estratégias?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "As operações estruturadas pela Feenex são desenhadas para resistir a qualquer questionamento fiscal. Contamos com pareceres jurídicos robustos, documentação completa e estruturas validadas. Nosso histórico de zero autuações em mais de 15 anos de operação com a Monetali é a melhor evidência da solidez das nossas soluções."
        }
      },
      {
        "@type": "Question",
        "name": "Como a Feenex garante a transparência e o acompanhamento das operações?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Cada cliente recebe relatórios mensais detalhados com todos os indicadores da operação, economia tributária acumulada e status de conformidade. Um gestor de conta dedicado está disponível para esclarecer dúvidas. Disponibilizamos auditoria independente a qualquer momento."
        }
      }
    ]
  }
];

export default function Home() {
  useEffect(() => {
    const existingScripts = document.querySelectorAll('script[data-schema="feenex-home"]');
    existingScripts.forEach((s) => s.remove());

    schemaOrg.forEach((schema, index) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'feenex-home');
      script.setAttribute('data-schema-index', String(index));
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      document.querySelectorAll('script[data-schema="feenex-home"]').forEach((s) => s.remove());
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Solutions />
      <HowItWorks />
      <Differentials />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}
